import React from 'react';
import SearchMoveForm from 'components/forms/SearchMoveForm';
import {Trans, useTranslation} from 'react-i18next';
import SearchResults from 'components/SearchResults';
import Button from 'components/Button';
import Box from '@mui/material/Box';
import {SearchObjectType, useSearchApi} from 'features/layout/DialogRoutes/dialogs/search/hooks';

type SearchSSHPublicKeysFormProps = {
   onClose?: () => void;
};

const SearchSSHPublicKeysForm = ({onClose}: SearchSSHPublicKeysFormProps) => {
   const {t} = useTranslation();
   const {results, search, exportResults} = useSearchApi(
      SearchObjectType.SSH,
      t('SSH Key Export'),
      t('Selected SSH keys successfully exported')
   );
   return (
      <>
         <SearchMoveForm
            searchFieldsLabel={t('Include all SSH Public keys or find keys with:')}
            searchResult={
               results ? <Trans t={t}>{{itemsCount: results.length}} keys found.</Trans> : null
            }
            onSubmit={search}
         />
         <SearchResults
            label={t('Double-click to edit a key.')}
            data={results}
            onExport={exportResults}
         />
         {onClose && (
            <Box textAlign={'center'}>
               <Button onClick={onClose}>{t('Close')}</Button>
            </Box>
         )}
      </>
   );
};

export default SearchSSHPublicKeysForm;
